import { phoneZones } from "./phoneZones.js";
import type { PhoneZone } from "./types.js";

export const i18nPhoneNumberRegex = /^\+[1-9]\d{6,14}$/;

const phoneZonesByPrefix = new Map<number, PhoneZone>();
phoneZones.forEach((phoneZone) => {
    phoneZonesByPrefix.set(phoneZone.prefix, phoneZone);
});

export function parsePhoneNumber(i18nPhoneNumber: string) {
    const phoneZone = guessInternationalPhoneZone(i18nPhoneNumber);
    if (!phoneZone) return null;
    const parsed = parseInternationalPhoneNumber(i18nPhoneNumber, phoneZone);
    return {
        phoneZone: phoneZone,
        valid: parsed.valid,
        local: parsed.parsed,
        international: i18nPhoneNumber,
    };
}

export function guessInternationalPhoneZone(i18nPhoneNumber: string) {
    let phoneZone: PhoneZone | undefined;
    for (const digits of [4, 3, 2, 1]) {
        const prefix = extractPrefix(i18nPhoneNumber, digits);
        const phoneZoneWithPrefix = phoneZonesByPrefix.get(prefix);
        if (!phoneZoneWithPrefix) continue;
        phoneZone = phoneZoneWithPrefix;
        break;
    }
    if (!phoneZone) return null;
    return phoneZone;
}

export function parseInternationalPhoneNumber(phoneNumber: string, zone: PhoneZone) {
    let charsLeft = phoneNumber.replace(`+${zone.prefix}`, "");
    let valid = true;
    let output = "";
    zone.mask.split("").forEach((c) => {
        if (charsLeft.length === 0) {
            valid = false;
            return;
        }
        const char = charsLeft[0];
        if (c === "0") {
            output += "0";
            if (char === "0") charsLeft = charsLeft.slice(1);
        } else if (c === "_") {
            output += char;
            charsLeft = charsLeft.slice(1);
        } else {
            output += c;
        }
    });
    if (charsLeft.length > 0) valid = false;
    return { parsed: output, valid };
}

export function formatInternationalPhoneNumber(phoneNumber: string, phoneZone: PhoneZone) {
    let charsLeft = phoneNumber.replace(/[^0-9]/g, "");
    let valid = true;
    let output = `+${phoneZone.prefix}`;
    phoneZone.mask.split("").forEach((c) => {
        if (charsLeft.length === 0) {
            valid = false;
            return;
        }
        const char = charsLeft[0];
        if (c === "0") {
            if (char === "0") {
                charsLeft = charsLeft.slice(1);
            } else {
                output += char;
                charsLeft = charsLeft.slice(1);
            }
        } else if (c === "_") {
            output += charsLeft.length > 0 ? charsLeft[0] : "";
            charsLeft = charsLeft.slice(1);
        }
    });
    if (charsLeft.length > 0) valid = false;
    return { international: output, valid, local: phoneNumber, phoneZone: phoneZone };
}

export function extractPrefix(phoneNumber: string, digits: number) {
    return Number(phoneNumber.slice(1, 1 + digits));
}

export function getPhoneZoneIMask(phoneZone: PhoneZone) {
    let mask = "";
    phoneZone.mask.split("").forEach((c) => {
        if (c === "0") {
            mask += "{0}";
        } else if (c === "_") {
            mask += "0";
        } else {
            mask += c;
        }
    });
    return mask;
}
